import { ReactComponent as SADet } from './icon_sa_det.svg';
import Icon, { IconProps } from './icon';

const IconSADet = (props: IconProps) => {
  return <Icon {...props} Svg={SADet} />;
};

export default IconSADet;
